/**
 * @module Services/Bff/Presenters/Request/PaymentDetail
 * @desc Payment Detail Presenter
 *
 */

import { hasPayload } from './utilities';

import type { Cart } from 'core/domains';

type PaymentDetailsPresenter = {
  creditCardSchema?: Cart['data']['paymentDetail']['creditCardSchema'];
  installments?: Cart['data']['paymentDetail']['installments'];
  paymentCode: number;
  paymentMode: Cart['data']['paymentDetail']['paymentMode'];
  paymentPlansByProduct?: Cart['data']['paymentDetail']['paymentPlansByProduct'];
};

// export function paymentDetailsPresenter(payload: undefined): undefined;

export function paymentDetailsPresenter(
  payload: undefined | Cart['data']['paymentDetail'],
): undefined | PaymentDetailsPresenter {
  if (!hasPayload(payload)) {
    return;
  }

  const { creditCardSchema, installments, paymentCode, paymentMode, paymentPlansByProduct } =
    payload;

  return {
    ...(creditCardSchema ? { creditCardSchema } : {}),
    ...(installments ? { installments } : {}),
    paymentCode: Number(paymentCode),
    paymentMode,
    paymentPlansByProduct: paymentPlansByProduct || [],
  };
}
